import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../theme';

const ProposalCard = ({ title, value, subtitle, progressValue, progressLabel }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      backgroundColor="#fff"
      borderRadius="12px"
      border="1px solid #272C3580"
      p="20px"
      display="flex"
      flexDirection="column"
      height="100%"
    >
      {title && (
        <Typography variant="h6" color={colors.grey[300]} mb="30px" fontWeight="700">
          {title}
        </Typography>
      )}

      {/* Progress Circle and Value */}
      <Box display="flex" alignItems="center" gap="20px">
        {/* Circular Progress */}
        <Box
          sx={{
            position: 'relative',
            width: 80,
            height: 80,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Background Circle */}
          <svg width="80" height="80" style={{ transform: 'rotate(-90deg)' }}>
            <circle cx="40" cy="40" r="32" fill="none" stroke={colors.grey[700]} strokeWidth="8" />
            {/* Progress Circle */}
            <circle
              cx="40"
              cy="40"
              r="32"
              fill="none"
              stroke={colors.greenAccent[400]}
              strokeWidth="8"
              strokeDasharray={`${2 * Math.PI * 32}`}
              strokeDashoffset={`${2 * Math.PI * 32 * (1 - progressValue)}`}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 0.5s ease' }}
            />
          </svg>
          {/* Percentage Text */}
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Typography variant="h5" fontWeight="bold" color={colors.grey[100]}>
              {Math.round(progressValue * 100)}%
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography
            variant="h1"
            fontWeight="bold"
            color={colors.grey[100]}
            sx={{ fontSize: '2.5rem' }}
          >
            {value}
          </Typography>
          <Typography variant="h5" color={colors.grey[200]} mb="auto">
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProposalCard;
